/**
 * Shared field definitions for VecDyn data tables
 * 
 * This file contains the field definitions used by VecDyn table components
 * to ensure consistency across the application.
 * 
 * USED BY:
 * - src/pages/vecdyn/SubmitVecdynData.vue
 * - src/pages/vecdyn/VecDynFileUploadDetail.vue
 * 
 * MAINTENANCE:
 * When adding new fields to the Django backend:
 * 1. Add the field to the Django model (timeseriesdata)
 * 2. Run Django migrations
 * 3. Add the field definition to this file (VECDYN_FILE_UPLOAD_DATA_TABLE_FIELDS array)
 * 4. Both Vue components will automatically pick up the changes
 * 
 * FIELD DEFINITION FORMAT:
 * Each field object should have:
 * - key: The field name (must match Django model field name)
 * - sortable: true/false (whether column can be sorted)
 * - tdClass: CSS classes for table cell styling
 * 
 * IMPORTANT: Keep this file in sync with Django model changes to prevent
 * display issues in the Vue components.
 */

export const VECDYN_FILE_UPLOAD_DATA_TABLE_FIELDS = [
  {
    key: 'DatasetID',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  // {
  //   key: 'RowUploadStatus',
  //   sortable: true,
  //   tdClass: 'text-truncate vt-table-cell'
  // },
  {
    key: 'contact_name',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'contributoremail',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'digitized_from_graph',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'location_description',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_end_date',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_lat_dd',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_long_dd',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_sex',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_stage',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_start_date',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_unit',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_value',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sampling_method',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'species',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'species_id_method',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'submittedby',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'title',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'additional_location_info',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'additional_sample_info',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'citation',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'class',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'collection_author_name',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'contact_affiliation',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'curatedbycitation',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'curatedbydoi',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'data_rights',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'dataset_license',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'date_uncertainty_due_to_graph', 
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'description', 
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'doi',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'email',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'embargo_release_date',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'family',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'figuretable',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'genus',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'geo_datum',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'gps_obfuscation_info',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'kingdom',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'notes',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'order',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'phylum',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'project_identifier',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'publication_status',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_collection_area',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_end_time',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_environment',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_location',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_name',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_start_time',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sampling_strategy',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'study_collection_area',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'study_design',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'subsampling_details',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'time_shift_possible',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'value_transform',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'collection_problem_flag',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'internally_inconsistent_flag',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'location_error',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'location_error_units',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'remarks_comments',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'sample_environment_measurements',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'species_identification_flag',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'physiological_status',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  },
  {
    key: 'tag',
    sortable: true,
    tdClass: 'text-truncate vt-table-cell'
  }
];
